var _g, _g2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgWomanHairstyle4A(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Ebene_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 720 720",
    enableBackground: "new 0 0 720 720",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "frame_730px"
  }, /*#__PURE__*/React.createElement("rect", {
    x: -4.8,
    y: -4.9,
    fill: "none",
    stroke: "#0000FF",
    strokeWidth: 0.25,
    strokeOpacity: 0,
    width: 730,
    height: 730
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "type4_x5F_hairstyles:"
  }, /*#__PURE__*/React.createElement("g", {
    id: "_x34_"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#862618",
    d: "M404.8,71.3c-2.2-0.6-4.6-1.2-7.3-1.7c-4.2-0.8-8.8-1.5-13.6-2c-0.9-0.1-1.8-0.2-2.7-0.3 c-8.9-0.8-18.3-1.1-27.3-0.7c-0.8,0-1.5,0.1-2.3,0.1c-5.5,0.3-10.8,0.9-15.5,1.8c-0.4,0.1-0.8,0.2-1.2,0.2 c-1.1,0.2-2.3,0.5-3.4,0.7c-9.6,2-19.3,4.7-27.7,9.9c-0.5,0.3-1.1,0.7-1.6,1c-2.8,1.9-5.5,3.8-7.7,6.1 c36.7-19.9,82.3-21.2,121-7.3C413.6,75,410,72.8,404.8,71.3z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#490500",
    d: "M291.5,98.8c1,3.1,3.2,5.8,5.7,7.5c6-3.5,12.2-6.4,18.6-8.8c6.4-2.3,12.9-4.1,19.6-5.4 c5-0.9,10.1-1.6,15.2-1.9s10.3-0.4,15.4-0.1c14.2,0.7,27.9,4,40.5,9.5c0.6-0.2,1.2-0.5,1.8-0.7C374,78.2,325.7,74.7,291.5,98.8z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#490500",
    d: "M400.8,32.9c-2.4-0.6-5.1-0.7-8.1-0.2c-0.2-0.3-0.3-0.6-0.5-0.8c-1,9.6-3.6,24.9-10.9,35.6 c0.9,0.1,1.8,0.2,2.7,0.3C392.3,61.2,400.8,45.1,400.8,32.9z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#490500",
    d: "M366.2,24.1c-2.9,0.9-5.6,2.4-8.2,4.5c-0.2,12.8-2.3,27.1-6.3,38.3c0.8,0,1.5-0.1,2.3-0.1 C363.7,56,366.7,35.6,366.2,24.1z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#490500",
    d: "M331.5,69.6c1.1-0.2,2.3-0.5,3.4-0.7c-9.3-9.6-16.6-21.9-17.3-34.4c0,0.1,0,0.1,0,0.2 c-2.6-0.1-5.3,0.1-7.8,0.6C310.7,50.6,321.4,63.6,331.5,69.6z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#711B0D",
    d: "M412.7,42c-2.5-4.3-6.5-7.8-11.9-9.1c0,12.1-8.5,28.3-16.9,34.8c4.8,0.5,9.4,1.2,13.6,2 c2.7,0.5,5.1,1,7.3,1.7c2.2-1.9,5.1-5.5,6.3-7C414.9,59.5,416.8,49,412.7,42z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#711B0D",
    d: "M366.2,24.1c0.6,11.5-2.4,31.9-12.2,42.7c8.9-0.4,18.4-0.1,27.3,0.7c7.4-10.7,9.9-26,10.9-35.6 C387.8,24.8,376.4,20.8,366.2,24.1z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#711B0D",
    d: "M357.8,28.8c-7.8-11.8-38.4-8.3-40.1,5.7c0.7,12.5,8,24.8,17.3,34.4c0.4-0.1,0.8-0.2,1.2-0.2 c4.7-0.9,10-1.5,15.5-1.8c4-11.1,6.1-25.5,6.3-38.3C357.9,28.7,357.9,28.7,357.8,28.8z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#711B0D",
    d: "M309.8,35.4c-3.8,0.8-7.4,2.4-10.4,5c-7.1,6.1-9.3,13.9-7.6,22.5c1.7,8.8,5.4,11.9,12.1,16.7 c8.3-5.2,18-7.9,27.7-9.9C321.4,63.6,310.7,50.6,309.8,35.4z"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#ABFF7F",
    strokeWidth: 0.1047,
    d: "M440,180.9L440,180.9L440,180.9C440.1,180.9,440,180.8,440,180.9z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M467.2,176.6c0-1.8,0-3.5-0.2-5.3l0,0C467.1,173.1,467.2,174.9,467.2,176.6z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M431.8,114.7c-0.9-0.7-1.9-1.5-2.8-2.2C429.9,113.2,430.9,114,431.8,114.7L431.8,114.7z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M426.1,110.5c0.9,0.6,1.7,1.2,2.5,1.8C427.8,111.7,427,111.1,426.1,110.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#862618",
    d: "M467.2,176.6c0,0.1,0,0.3,0,0.4C467.2,176.9,467.2,176.8,467.2,176.6z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#862618",
    d: "M425.6,110.1c0.2,0.1,0.4,0.2,0.5,0.4C426,110.4,425.8,110.3,425.6,110.1z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#862618",
    d: "M458.4,145.8c-6.6-12.1-15.8-22.6-26.6-31.1l0,0c-0.9-0.7-1.9-1.5-2.8-2.2c-0.1-0.1-0.2-0.2-0.3-0.2 c-0.8-0.6-1.7-1.2-2.5-1.8c-0.2-0.1-0.4-0.2-0.5-0.4c-5.9-4-12.3-7.5-18.9-10.4c-12.6-5.5-26.4-8.8-40.5-9.5 c-5.1-0.3-10.3-0.3-15.4,0.1c-5.1,0.3-10.2,1-15.2,1.9c-6.7,1.3-13.3,3.1-19.6,5.4c-6.4,2.3-12.7,5.3-18.6,8.8 c-23,13.4-41.9,34.8-48.9,59.2c-1.8,10.6-1.1,21.9,6.4,26.9c3.8,2.5,9.3,3.9,13.8,2.5c1.5-1.7,2.4-3.8,2.7-6.1 c-4.3-19.6-5.4-42.6,10.2-58.2c-13.6,19.8-8.3,44.4-6.1,56.9c8-0.4,12-9.2,12.5-17.6c-0.8-20.2,1.1-46.8,22.1-62.2 c-16.1,17.3-20.6,38.8-18.3,60.1c10.8,0.4,19.8-5.5,22.1-13.7l0.1,0.1c-2.5-17.8-1.3-40.5,14.2-53.9c-10.5,12.4-15.4,38-9.7,56.7 c6,1.9,13.4-1.5,15.7-6c0.1,0.1,0.2,0.2,0.3,0.2c-2.8-17.8,0.6-39.4,11.3-54c-5,11.8-12.3,28.2-8,55.7c4.1,1,9.6-0.9,12.4-3.3 c0.1,0.2,0.2,0.5,0.3,0.7c-1.6-18.5,1.6-38.5,13.6-53.1c-9.4,17-12.5,37.8-9.3,57.2c5.1,2.6,12.9,2,16.2-2.6 c5.9-17.5,6.7-36.9,2.9-54.6c7.6,16.1,5.4,38.8-0.1,56.3c3.8,3.2,9.4,4,14,2.4c6.5-17.8,6.4-40.8,2.6-54.2 c7.7,14.8,6.5,34.7,2,51.5c0,0,0,0,0.1-0.1c0.7,4.1,6.6,9.8,10.6,11.4c4.5,1.8,7.8,1.9,12.1,0.5c4-19.3-0.1-44.2-4.5-51.6 c11.3,13.2,11,35.6,8.2,50.3c0.1,0,0.1-0.1,0.2-0.1c0.3,10.2,8.9,18.3,16.6,18.4c7.9-19.1,2.8-43.5-3.3-57.8 c13.2,19.3,13.2,43.3,7.7,58.4c-1.7,10.2,6.6,14.4,10.9,14.9c0.6,0.1,1.1,0.1,1.7,0.1c8-0.2,12.8-8.5,14.3-14.2 c0.1-0.3,0.1-0.6,0.2-0.9c0.3-1.8,0.4-3.7,0.4-5.5c0-0.1,0-0.3,0-0.4c0-1.8-0.1-3.5-0.2-5.3l0,0c-0.9-9.1-4.3-17.6-8.7-25.5 L458.4,145.8L458.4,145.8z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#5D1002",
    d: "M408.5,99c5-2.4,9.8-7.3,9-12.9c-0.4-2.7-1-4.9-1.9-6.7c-38.7-14-84.3-12.7-121,7.3 c-2.2,2.4-3.7,5.3-3.7,8.8c0,1.2,0.2,2.3,0.6,3.4C325.7,74.7,374,78.2,408.5,99z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#5D1002",
    d: "M254.4,197.5c-3.6-1.7-5.9-5-7.2-8.8c-11.4,2.9-14.9,18.7-3.3,25c-5.9,5.3-2.1,18.5,4.4,22.6 c2-1.1,4.9-0.8,7,0c2.6,0.9,3.4,3.4,5.5,4.4c4.7,2.2,8.8-7.8,9.2-10.8c0.5-3.8-2.1-9.6-6.3-10.3c6.5-5.4,6-16.2-0.8-21.1 C260.3,199.1,257.4,198.8,254.4,197.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#5D1002",
    d: "M452.3,197.5c-6.1,5.8-7,17.5,4.5,21.2c-3.2,3-5.7,8.5-5.2,12.5c0.4,3.1,2.7,8.9,7.4,6.6 c2-1,0.7-0.4,3.2-1.4c2.2-0.8,5.1-0.7,8.1-0.2c8.3-7.9,17.1-27.8,5.8-33.8c8.7-5.7,3.1-16.7-9.5-19.2 C465.1,189,460.3,197.3,452.3,197.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#5D1002",
    d: "M481.3,177.5c-11.6-11.2-12.1-27.7-23.4-39.3c12.3,3.1,23.1,10.2,25.9,22.2c2.4-3.2-0.1-15.4-1.6-19.4 c-2.2-6-5.3-8.9-10.8-12.9c-7-5.1-15.3-7-23.5-8.9c-4.8-1.1-10.6-2.5-16-4.5c10.8,8.6,19.9,19.1,26.6,31.1h-0.1 c4.3,8,7.8,16.5,8.7,25.5c4.5,4.5,12,6.1,17.4,8.2C483.1,179.1,482.3,178.4,481.3,177.5z"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#862618",
    d: "M428.7,112.3c0.1,0.1,0.2,0.2,0.3,0.2C428.9,112.5,428.8,112.4,428.7,112.3z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00C200",
    d: "M440,180.9L440,180.9L440,180.9C440.1,180.9,440,180.8,440,180.9z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#AB503E",
    d: "M254.8,192.4c-7.6-5-8.2-16.3-6.4-26.9c-1.3,4.5-2.2,9.1-2.6,13.7c0,3.1,0.4,6.4,1.4,9.4 c1.3,3.8,3.6,7.1,7.2,8.8c2.9,1.4,5.9,1.6,8.5,0.9c2.3-0.6,4.2-1.8,5.7-3.5C264.1,196.3,258.6,194.9,254.8,192.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#AB503E",
    d: "M271.3,188.8c0.1-0.6,0.1-1.2,0-1.8c1.5,0.4,2.9,0.5,4.1,0.5c-2.2-12.4-7.6-37.1,6.1-56.9 C265.8,146.2,267,169.2,271.3,188.8z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#AB503E",
    d: "M431.9,124.2c6.1,14.3,11.2,38.6,3.3,57.8c1.6,0,3.3-0.3,4.7-1.1l0,0c0-0.1,0.1-0.1,0,0l0,0 c-0.1,0.6-0.3,1.1-0.3,1.7C445.1,167.5,445.1,143.5,431.9,124.2z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#AB503E",
    d: "M414.7,165.1c1.1-0.4,2.3-0.8,3.7-1.4c2.8-14.7,3.1-37-8.2-50.3C414.7,120.9,418.8,145.7,414.7,165.1z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#AB503E",
    d: "M287.9,169.9c0.1-0.8,0.1-1.7,0.1-2.5c1.3,0.2,2.5,0.3,3.7,0.3c-2.4-21.3,2.2-42.7,18.3-60.1 C289.1,123.1,287.1,149.7,287.9,169.9z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#AB503E",
    d: "M334.2,151.2c0.9,0.9,2,1.4,3.2,1.7c-4.2-27.5,3-43.9,8-55.7C334.8,111.8,331.4,133.4,334.2,151.2z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#AB503E",
    d: "M313.9,154.2c1.3,1.4,2.8,2.3,4.4,2.8c-5.7-18.7-0.7-44.3,9.7-56.7C312.6,113.7,311.4,136.4,313.9,154.2z "
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#AB503E",
    d: "M370.5,151.8c0.2-0.3,0.3-0.5,0.5-0.8c0.7,1,1.5,1.8,2.4,2.6c5.4-17.6,7.6-40.2,0.1-56.3 C377.2,114.8,376.5,134.3,370.5,151.8z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#AB503E",
    d: "M387.4,156c1.7-0.6,3.3-1.5,4.6-2.8c4.5-16.8,5.7-36.6-2-51.5C393.8,115.2,393.9,138.2,387.4,156z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#AB503E",
    d: "M350.1,150.3c0.8,1.7,2.4,3.1,4.2,4.1c-3.2-19.4-0.1-40.2,9.3-57.2C351.8,111.8,348.5,131.9,350.1,150.3z "
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#AB503E",
    d: "M467,171.4L467,171.4c-0.4-3.7-1.2-7.3-2.3-10.8c1.7,7.7,1.9,15.9-0.7,22.4c-2.4,5.9-8.5,12.5-15.4,14.1 c0.7,0.2,1.4,0.4,2,0.4c0.6,0.1,1.1,0.1,1.7,0.1c8-0.2,12.8-8.5,14.3-14.2c0.1-0.3,0.1-0.6,0.2-0.9c0.3-1.8,0.4-3.7,0.4-5.5 c0-0.1,0-0.3,0-0.4C467.2,174.9,467.1,173.1,467,171.4z"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWomanHairstyle4A);
export default __webpack_public_path__ + "static/media/woman_hairstyle_4a.b9561b9a6cb62af33519dec79f6aa49d.svg";
export { ForwardRef as ReactComponent };